<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Epigraphs</a></p>
<p class="part"><a href="#/c001">PART ONE</a></p>
<p class="toc"><a href="#/c01">Famous in Kampala</a></p>
<p class="toc"><a href="#/c02">“I’m Not Everyone”</a></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">The Kaptagat Arms</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">On Safari in Rwanda</span></p>
<p class="part"><span href="#/c002" title="Link target outside of Sample">PART TWO</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Christmas Pudding</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Excursion to Oxford</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Air Letters: A Correspondence Course</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">The 9:50 to Waterloo</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">“<em>I Must Keep</em> Some <em>Secrets</em>”</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample"> Lunch Party</span></p>
<p class="part"><span href="#/c003" title="Link target outside of Sample">PART THREE</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">The Householder</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">My Friend’s Friend</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Death Is the Motif</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Tainted Vegetables</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">“It’s Major” </span></p>
<p class="part"><span href="#/c004" title="Link target outside of Sample">PART FOUR</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">Poetry of Departures</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">A Wedding Is a Happy Funeral</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">Literature Is for the Wounded and the Damaged</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">Exchanges</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">Sir Vidia’s Shadow</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Afterword: Memory and Invention</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c0bbb3fa